import {useMutation} from "@tanstack/react-query";
import {addOfferTemplateNoteMutationOptions} from "./add-offer-template-note.mutation-options";

export function useAddOfferTemplateNote(id: string) {
  return useMutation(addOfferTemplateNoteMutationOptions(id));
}
